import React, { useState, useEffect, useRef }   from "react";
import { useNavigate }                          from "react-router-dom";
import BtnChangeTheme                           from "components/Buttons/Theme/BtnTheme";
import {useModal}                               from "components/Covers/genericModal";
import Style                                    from 'components/UI/main.module.scss';
import {    
            GetSystemLabel, 
            SetAppLang,
            ValidateBusinessRulesForMenu,
            AppFeature,
            GetBusinessLabel,
            AppTheme,
            isDarkMode,
        }                                       from "Utilities/utils";
import FeedbackLogo                             from "components/Logo/logo";

// This will manage the state globally
// this component render contents of menu displayed by another
// jsx component and displays the component and the information about
// the component
let showMenuCallback       = null;
let hideMenuCallback       = null;

function getLastFeatureBlock({refArr, clickAction}){
    let f = localStorage.getItem("last_feature");
    if (f) {
        let founded = refArr.find((i) => i === parseInt(f));
        if (founded) {
            clickAction(true);
        }
    }
}
export const useMenu                = () => {
  return { showMenu: showMenuCallback, hideMenu:  hideMenuCallback};
};
const Feature                       = React.memo(({ objKey, ifeature, toggleMenu }) => {
    const navigate                = useNavigate();

    const obj = AppFeature(ifeature);

    function clickHandler () {
        switch(ifeature) {
            case 12:
            break;            
            case 13:
            break;
            case 14:
            break;
            case 11:
            break;            
            default:
            break;
        }
        if (window.location.pathname !== `/${obj.path}`) {
            navigate(`/${obj.path}`);
            toggleMenu();
        }
        else {
            return;
        }
    }
    const IsCurrent = () => {
        let data = localStorage.getItem("last_feature");
        if (data) {
        return (parseInt(data) == ifeature ? true : false);
        }
        return false;
    };

    return (
        <div 
            key={objKey}
            value={ifeature}
            className={[Style.row, 
                        Style.clickable, 
                        IsCurrent() ? Style.sidebar_active_bg : Style.sidebar_bg,
                        Style.p_2].join(" ")}
            onClick={() => {
                clickHandler();
            }}  
        >
            <div className={Style.col}>
                <div className={[Style.text_start, Style.ms_3].join(" ")}>
                    <span className={[Style.fs_8, Style.text_body].join(" ")}>
                    {obj.desc}
                    </span>
                </div>
            </div>            
        </div>
    );
});
const FeaturesBlock_0               = React.memo(({toggleMenu}) => {
    const [elements, setElements]     = useState([]);
    const [isOpen, setIsOpen]         = useState(false);  // state

    const handleClick = () => {
        setIsOpen(prev => !prev);
    };

    function getData() {
        let raw_data = localStorage.getItem("Charlore");
        if (raw_data) {      
            let stack           = [];
            let obj             = ValidateBusinessRulesForMenu();

            for (let i = 0; i< obj.Block_0.length; i++) {
                stack.push(
                    <Feature 
                        toggleMenu={toggleMenu}
                        key={obj.Block_0[i]} 
                        ifeature={obj.Block_0[i]} 
                    />
                );                
            }
            setElements(stack);
        }
    }

    useEffect(() => {
        getData();
        getLastFeatureBlock({refArr: [1,2], clickAction: setIsOpen});
    },[]);

    return(
        <>
            {elements.length > 0 && (
            <>
                <div    className={[Style.row, Style.clickable, Style.sidebar_bg, Style.py_2, Style.pop_item_animation].join(" ")} 
                        onClick={handleClick}
                >
                    <div className={Style.col_2}>
                        <div className={[Style.d_flex, Style.justify_content_center, Style.align_middle].join(" ")}>
                            <svg 
                                xmlns="http://www.w3.org/2000/svg" 
                                viewBox="0 0 384 512"
                                className={Style.sidebar_btn_ico_tag}
                            >
                                <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128z"/>
                            </svg>
                        </div>              
                    </div>
                    <div className={Style.col_10}>
                        <div className={[Style.text_start].join(" ")}>
                            <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                {GetBusinessLabel("MenuHeaderBlockMain")}
                            </span>
                        </div>
                    </div>
                </div>
                <div    className={[
                            Style.overflow_y_scroll,
                            isOpen ? Style.sidebar_animation_open : Style.sidebar_animation_close
                        ].join(" ")}
                >
                    {elements}
                </div>
            </>
            )}
        </>
    );
});
const FeaturesBlock_1               = React.memo(({toggleMenu}) => {
    const [elements, setElements]     = useState([]);
    const [isOpen, setIsOpen]         = useState(false);  // state

    const handleClick = () => {
        setIsOpen(prev => !prev);
    };

    function getData() {
        let raw_data = localStorage.getItem("Charlore");
        if (raw_data) {      
            let stack           = [];
            let obj             = ValidateBusinessRulesForMenu();

            for (let i = 0; i< obj.Block_1.length; i++) {
                stack.push(
                    <Feature 
                        toggleMenu={toggleMenu}
                        key={obj.Block_1[i]} 
                        ifeature={obj.Block_1[i]} 
                    />
                );                
            }
            setElements(stack);
        }
    }

    useEffect(() => {
        getData();
        getLastFeatureBlock({refArr: [3], clickAction: setIsOpen});
    },[]);

    return(
        <>
            {elements.length > 0 && (
                <>
                    <div    className={[Style.row, Style.clickable, Style.sidebar_bg, Style.py_2, Style.pop_item_animation].join(" ")} 
                            onClick={handleClick}
                    >
                        <div className={Style.col_2}>
                            <div className={[Style.d_flex, Style.justify_content_center, Style.align_middle].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 448 512"
                                    className={Style.sidebar_btn_ico_tag}
                                >
                                    <path d="M160 80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-352zM0 272c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48L0 272zM368 96l32 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48z"/>
                                </svg>
                            </div>              
                        </div>
                        <div className={Style.col_10}>
                            <div className={[Style.text_start].join(" ")}>
                                <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                    {GetBusinessLabel("MenuHeaderBlockReports")}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div    className={[
                                Style.overflow_y_scroll,
                                isOpen ? Style.sidebar_animation_open : Style.sidebar_animation_close
                            ].join(" ")}
                    >
                        {elements}
                    </div>
                </>
            )}
        </>
    );
});
const FeaturesBlock_2               = React.memo(({toggleMenu}) => {
    const [elements, setElements]     = useState([]);
    const [isOpen, setIsOpen]         = useState(false);  // state

    const handleClick = () => {
        setIsOpen(prev => !prev);
    };

    function getData() {
        let raw_data = localStorage.getItem("Charlore");
        if (raw_data) {      
            let stack           = [];
            let obj             = ValidateBusinessRulesForMenu();

            for (let i = 0; i< obj.Block_2.length; i++) {
                stack.push(
                    <Feature 
                        toggleMenu={toggleMenu}
                        key={obj.Block_2[i]} 
                        ifeature={obj.Block_2[i]} 
                    />
                );                
            }
            setElements(stack);
        }
    }

    useEffect(() => {
        getData();
        getLastFeatureBlock({refArr: [4,5,6,7,8], clickAction: setIsOpen});
    },[]);

    return(
        <>
            {elements.length > 0 && (
                <>
                    <div    className={[Style.row, Style.clickable, Style.sidebar_bg, Style.py_2, Style.pop_item_animation].join(" ")} 
                            onClick={handleClick}
                    >
                        <div className={Style.col_2}>
                            <div className={[Style.d_flex, Style.justify_content_center, Style.align_middle].join(" ")}>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    viewBox="0 0 576 512"
                                    className={Style.sidebar_btn_ico_tag}
                                >
                                    <path d="M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5l0 112.2c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7L0 413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3l0-119.1c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3l0-112.2c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2 0-89.2L392 121l0 89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4l0-100.5L256 323.2l0 95.9-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1 0-100.5L528 323.2l0 90.7c0 3.2-1.9 6-4.8 7.3z"/>
                                </svg>
                            </div>              
                        </div>
                        <div className={Style.col_10}>
                            <div className={[Style.text_start].join(" ")}>
                                <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                    {GetBusinessLabel("MenuHeaderBlockAdministration")}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div    className={[
                                Style.overflow_y_scroll,
                                isOpen ? Style.sidebar_animation_open : Style.sidebar_animation_close
                            ].join(" ")}
                    >
                        {elements}
                    </div>
                </>
            )}
        </>
    );
});
const UserOverView                  = React.memo(({toggleMenu}) => {
    const [userData, setUserData] = useState({});
    const navigate                = useNavigate();

    function getUserData() {
        let data = localStorage.getItem("Charlore");
        if (data) {      
            let parsedData = JSON.parse(data);
            setUserData(parsedData);
        }
    }

    function handleClick () {
        toggleMenu();
        navigate("/user_config");
    }

    useEffect(() => {
        getUserData();
    }, []);

    return (
    <div className={Style.m_3}>
        <div className={[Style.row, Style.mb_3].join(" ")}>
            <div className={[Style.col, Style.align_self_center].join(" ")}>
                <div className={[Style.fs_8, Style.text_body].join(" ")}>
                    {(GetSystemLabel("MenuGreetings") ?? "").replace('$placeholder', userData?.FullName)}
                </div>
            </div>
        </div>
        <div className={[Style.row, Style.pop_item_animation].join(" ")}>
            <div className={Style.col}>
                <div onClick={() => {handleClick();}} className={[Style.fs_8, Style.text_body, Style.fw_semibold, Style.clickable].join(" ")}>
                    {GetSystemLabel("MenuAccountPreferences")}
                </div>
            </div>
        </div>
    </div>
    );

});
const LangSelector                  = React.memo(() => {
    return (
        <div className={Style.row}>
            <div className={Style.col}>
                <div className={[Style.d_flex, Style.justify_content_around, Style.my_1].join(" ")}>
                    <div className={[ Style.sidebar_middle_btn].join(" ")}
                        onClick={()=> {SetAppLang("Pt"); window.location.reload();}}
                    >
                        <div className={[Style.d_flex, Style.justify_content_center, Style.align_items_middle, Style.clickable].join(" ")}>
                            <span className={Style.text_body}>Pt</span>
                        </div>
                    </div>
                    <div className={[ Style.sidebar_middle_btn].join(" ")}
                        onClick={()=> {SetAppLang("En"); window.location.reload();}}
                    >
                        <div className={[Style.d_flex, Style.justify_content_center, Style.align_items_middle, Style.clickable].join(" ")}>
                            <span className={Style.text_body}>En</span>
                        </div>
                    </div>
                    <div className={[ Style.sidebar_middle_btn].join(" ")}
                        onClick={()=> {SetAppLang("Es"); window.location.reload();}}
                    >
                        <div className={[Style.d_flex, Style.justify_content_center, Style.align_items_middle, Style.clickable].join(" ")}>
                            <span className={Style.text_body}>Es</span>
                        </div>
                    </div>
                </div>                
            </div>
        </div>
    );
});
const BtnMenu                       = ({toggleMenu}) => {
  return(
        <div    onClick={() => {toggleMenu();}} 
                className={[    Style.d_flex, 
                                Style.justify_content_center, 
                                Style.align_items_center, 
                                Style.header_bg, 
                                Style.shadow_sm, 
                                Style.border, 
                                Style.clickable, 
                                Style.rounded_bottom].join(" ")}
        >
            <div className={[Style.px_2, Style.py_1].join(" ")}>
            <svg    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 -40 448 512"
                    className={[ Style.sidebar_btn].join(" ")}
            >
                <path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/>
            </svg>
            </div>
        </div>
  );
};
const BtnHome                       = React.memo(({clickAction}) => {
    return (
        <div className={[Style.d_flex, Style.justify_content_center, Style.align_items_middle].join(" ")} onClick={() => {clickAction();}} >            
            <svg    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 640 640"
                    className={[ Style.sidebar_middle_btn, Style.clickable].join(" ")}

            >
                <path d="M341.8 72.6C329.5 61.2 310.5 61.2 298.3 72.6L74.3 280.6C64.7 289.6 61.5 303.5 66.3 315.7C71.1 327.9 82.8 336 96 336L112 336L112 512C112 547.3 140.7 576 176 576L464 576C499.3 576 528 547.3 528 512L528 336L544 336C557.2 336 569 327.9 573.8 315.7C578.6 303.5 575.4 289.5 565.8 280.6L341.8 72.6zM304 384L336 384C362.5 384 384 405.5 384 432L384 528L256 528L256 432C256 405.5 277.5 384 304 384z"/>
            </svg>                    
        </div>
    );
});
const Back                          = React.memo(({clickAction}) => {
    return(
        <div    className={[    Style.row, 
                                Style.py_2, 
                                Style.clickable,
                                Style.sidebar_bg,
                                Style.pop_item_animation, 
                        ].join(" ")} 
                onClick={() => {clickAction();}}
        >
            <div className={Style.col_2}>
            <div className={[Style.d_flex, Style.justify_content_center, Style.align_middle].join(" ")}>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 448 512"
                    className={Style.sidebar_ico}
                >
                <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/>
                </svg>                     
            </div>              
            </div>
            <div className={Style.col_10}>
            <div className={[Style.text_start].join(" ")}>
                <span className={[Style.fs_8, Style.text_body].join(" ")}>{GetSystemLabel("Return")}</span>
            </div>
            </div>
        </div>
    );
});
const Logout                        = React.memo(({clickAction}) => {
    return(
        <div    className={[    Style.row, 
                                Style.py_2, 
                                Style.clickable,
                                Style.sidebar_bg,
                                Style.pop_item_animation].join(" ")}
                onClick={() => {
                    clickAction();
                }}
        >
            <div className={Style.col_2}>
            <div className={[Style.d_flex, Style.justify_content_center, Style.align_middle].join(" ")}>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 576 512"
                    className={Style.sidebar_ico}
                >
                    <path d="M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5L64 448l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 192 0 32 0 0-32 0-448zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128l96 0 0 352c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-320c0-35.3-28.7-64-64-64l-96 0 0 64z"/>
                </svg>
            </div>              
            </div>
            <div className={Style.col_10}>
            <div className={[Style.text_start].join(" ")}>
                <span className={[Style.fs_8, Style.text_body].join(" ")}>{GetSystemLabel("Exit")}</span>
            </div>
            </div>            
        </div>
    );
});
const LogoutContent                 = React.memo(({clickAction}) => {
    return (
        <div>
            <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                    <div className={[Style.p_3].join(" ")}>
                        <span className={[Style.text_body, Style.fs_8].join(" ")}>
                            {GetSystemLabel("AskForConfirmation")}
                        </span>
                    </div>
                </div>
            </div>
            <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                <div className={[Style.p_2].join(" ")}>
                    <div    className={[    Style.primary_bg, 
                                            Style.clickable, 
                                            Style.rounded_3, 
                                            Style.border, 
                                            Style.text_white,
                                            Style.text_center,
                                            Style.pop_item_animation].join(" ")}
                            onClick={() => {clickAction();}}
                    >
                        <div className={[Style.my_2, Style.mx_3].join(" ")}>
                            <span className={[Style.fs_8].join(" ")}>{GetSystemLabel("Proceed")}</span>
                        </div>
                    </div>
                </div>
            </div>                
        </div>
    );
});

export const Menu                   = () => {
    const [isMenuOpen,  setIsMenuOpen ]    = useState(false);  // state
    const [isSliding,   setIsSliding  ]    = useState(true);  // slide animation
    const { showModal                 }    = useModal();
    const navigate                         = useNavigate();

    showMenuCallback = () => {
        setIsSliding(false);
        setTimeout(() => setIsSliding(true), 100); // Show content after sliding
        setTimeout(() => setIsMenuOpen(true), 101);
    };

    const sidebarClass = [
        isMenuOpen ? Style.sidebar_expanded : Style.sidebar_retracted,
        isSliding ? Style.slide_in : Style.slide_out,
    ].join(" ");

    const openMenu = () => {
        setIsSliding(false);
        setTimeout(() => setIsSliding(true), 100); // Show content after sliding
        setTimeout(() => setIsMenuOpen(true), 101);
    };

    // Function to close menu with animation
    const closeMenu = () => {
        setIsSliding(false);
        setTimeout(() => setIsSliding(true), 100); // Show content after sliding
        setTimeout(() => setIsMenuOpen(false), 101);
    };

    const toggleMenu = () => {
        if (!isMenuOpen) {     
            openMenu(); 
        } 
        else {
            closeMenu();
        }
    };

    function logoutUser() {
        localStorage.removeItem("Charlore");
        localStorage.removeItem("Tolkien");
        localStorage.removeItem("last_feature");
        navigate("/");
    };

    const logout = () => {
        showModal(
            <LogoutContent clickAction={()=> {logoutUser();}}/>
        );
    }

    return(
    <>
        <div className={sidebarClass}>
            {
            !isMenuOpen ? 
                <div className={[Style.d_flex, Style.justify_content_center, Style.align_items_middle].join(" ")}>
                    <BtnMenu          toggleMenu  ={toggleMenu} />
                </div>
            :
            <>
                <div className={[Style.row, Style.mx_1, Style.py_3].join(" ")}>
                    <div className={[Style.col_8, Style.d_flex, Style.justify_content_center, Style.align_items_center,].join(" ")}>
                        <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                            <FeedbackLogo 
                                width={180}
                                defaultBrandStyle={false}
                                brandStyle={ isDarkMode()   ? {fill: "#ffffff"} : {fill: "#4d4d4f"}}
                                textStyle={ isDarkMode()    ? {fill: "#ffffff"} : {fill: "#4d4d4f"}}
                            />
                        </div>
                    </div>
                    <div className={[Style.col_2, Style.d_flex, Style.justify_content_center, Style.align_items_center,].join(" ")}>
                        <BtnHome clickAction={() => {toggleMenu(); navigate("/home");}}/>
                    </div>
                    <div className={[Style.col_2, Style.d_flex, Style.justify_content_center, Style.align_items_center,].join(" ")}>
                        <BtnChangeTheme/>
                    </div>            
                </div>
                <LangSelector/>
                <Back            clickAction={toggleMenu}/>
                <UserOverView    toggleMenu={toggleMenu}/>          
                <FeaturesBlock_0 toggleMenu={toggleMenu}/>
                <FeaturesBlock_1 toggleMenu={toggleMenu}/>
                <FeaturesBlock_2 toggleMenu={toggleMenu}/>
                <Logout          clickAction={logout}/>
            </>
            }
        </div>
        { isMenuOpen ? <div style={{zIndex: 99}}className={[Style.loading_cover].join(" ")} onClick={() => closeMenu()}></div> : null }
    </>
    );

};
export const NavBar                 = ({children}) => {
    return (
        <div className={[Style.nav_bar].join(" ")}>
            {children}
        </div>
    )
};
